/**
 * Form CheckboxField component
 *
 * @remarks
 */

import {
  Checkbox,
  FormControl,
  FormErrorMessage,
  Text,
} from "@chakra-ui/react";

import { FC, ReactNode, forwardRef, ChangeEvent } from "react";

export interface ICheckboxField {
  label?: string;
  error?: boolean;
  helperText?: string | ReactNode;
  isChecked?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxField: FC<ICheckboxField> = forwardRef(
  (props: ICheckboxField, ref) => {
    const { label, error, helperText, isChecked, onChange } = props;

    return (
      <FormControl isInvalid={error}>
        <Checkbox
          colorScheme="teal"
          size="lg"
          spacing="1.2rem"
          className="signup-checkbox"
          isChecked={isChecked}
          onChange={onChange}
        >
          <Text color="hjsBlack" fontSize={[14, 14, 17, 20]}>
            {label}
          </Text>
        </Checkbox>
        {Boolean(error) && (
          <FormErrorMessage fontSize={[14, 14, 18]}>
            {helperText}
          </FormErrorMessage>
        )}
      </FormControl>
    );
  }
);

CheckboxField.defaultProps = {
  label: "",
  error: false,
  helperText: "",
  isChecked: false,
};

export default CheckboxField;

CheckboxField.displayName = "CheckboxField";
